import React, { useEffect } from "react";
import { Modal, Form, Input, InputNumber, Select, DatePicker, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { save } from "../../../../features/save/saveSlice";
import toast from "react-hot-toast";

const RolesAdd = ({ isModalOpen, handleCancel, handleFetch, prodd }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { saving } = useSelector((state) => state.save);

  const onFinish = async (data) => {
    data.prId = prodd?.prId ?? null;
    const res = await dispatch(save({ ...data, url: "v1/ap/panel-roles/create" }));
    if (res?.payload?.success) {
      toast.success(res?.payload?.messages?.message);
      handleCancel();
      handleFetch();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  useEffect(() => {
    if (prodd) {
      form.setFieldsValue({ ...prodd });
    } else {
      form.resetFields();
    }
  }, [prodd]);

  return (
    <Modal
      title={`${prodd?.prId ? "Update" : "Add"} Roles`}
      open={isModalOpen}
      onCancel={handleCancel}
        width={850}
      onOk={onFinish}
    >
      <Form layout="vertical" form={form} onFinish={onFinish}>
        <Form.Item
          label="Name"
          name="prName"
          rules={[{ required: true, message: "Please enter Name" }]}
        >
          <Input className="input" />
        </Form.Item>
      <div className="flex lg:flex-row flex-col justify-between mt-[56px] mb-[48px]">
          <div className="justify-start"></div>
          <div className="justify-end flex items-center gap-x-2">
            <div className="w-[200px]">
              <button
                key="back"
                type="button"
                onClick={handleCancel}
                className="cstm-btn-2"
              >
                Cancel
              </button>
            </div>

            <div className="w-[200px]">
              <button
                key="submit"
                type="submit"
                className="cstm-btn"
                disabled={saving}
              >
                {saving ? <Spin /> : prodd?.jexId ? "Update" : "Save"}
              </button>
            </div>
          </div>
        </div>
      </Form>
    </Modal>
  );
};

export default RolesAdd;